export default "__VITE_ASSET__BnMi7PQL__"